import React from "react";

function RoleLoader() {
  return (
    <div className="h-5 bg-gray-100 rounded-full w-full animate-pulse my-3.5"></div>
  );
}

export default RoleLoader;
